import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import constant, { functionsCode } from '../../../../constants/constant'
import moment from "moment";
// Antd
import { Typography, Row, Col, Icon} from "antd";

// Formik
import { FastField, Formik } from "formik";

// Yup
import * as Yup from "yup";

// Component
import Button from "../../../../components/Buttons";
import Input from "../../../../components/Common/Input";
import typo, {MESSAGE} from "../../../../constants/dictionaries";
import Select from "../../../../components/Common/Select";
import message from "../../../../components/Messages";
import DateField from "../../../../components/Common/DateField"
import ValidatedText from "../../../../components/Common/ValidatedText";


// Colors
import colors from "../../../../constants/colors";

// Styled components
import styles from "./Modal.module.scss";
import Api_tnn from "../../../../api/api.tnn";
import Api_quantrac from "../../../../api/api.quantrac";
import Helper from "../../../../helper/helper";
import Box from "../../../../components/Box";
import MDSD from "../../../../components/AttachTable/MDSD/Table"
const { Text } = Typography;

const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const ControllerMDSD = styled.div`
  padding: 20px 20px 0 20px;
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;

const dataSelect = [
  { 
    ten: "Có hiệu lực",
    value: 1,
  },
  {
    ten: "Không hiệu lực",
    value: 2,
  }
]
const dateFormat = 'DD/MM/YYYY';
// Validations for add user
const addOrEditSchema = Yup.object().shape({
    maQuyChuan: Yup.string(),

    tenQuyChuan: Yup.string().required(typo.cscore_input_Required),

    coQuanBanHanh: Yup.string(),

    hieuLuc: Yup.string(),
   
    vanBanDinhKem: Yup.string(),

});

class AppliStanModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataMDSD: [],
      dataPost: {
        QT_DMQCVN: undefined,
        QT_MucDichSuDungs: undefined
      },
      initialValues: {}
    };
  }

  componentDidMount() {
    const {isEdit, MucDichSuDung, selectedRow, doituongQT} = this.props
    if(isEdit){
      this.setState({
        dataMDSD: MucDichSuDung,
        initialValues: {...selectedRow, tpmT_Ma: Number(doituongQT)}
      })
    } else {
      this.setState({
        initialValues: {...this.state.initialValues, tpmT_Ma: Number(doituongQT) }
      })
    }
  }

  handleUpdateMDSD = (value) => {
    this.setState({
      dataMDSD: value
    })
  }
  render() {
    const {
      handleCloseModal,
      selectedRow,
      isEdit,
      handleAdd, 
   
    } = this.props;
    const {initialValues, dataMDSD} = this.state
    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={addOrEditSchema}
          onSubmit={(values, actions) => {
            this.setState({
              dataPost: {
                QT_DMQCVN: {...values, tpmT_Ma: values.tpmT_Ma},
                QT_MucDichSuDungs: this.state.dataMDSD

              }
            })
            if (isEdit) {
              new Api_quantrac()
                .PutQT_DMQCVN_TNN({
                  token: this.props.user.access_token,
                  dmqcvn_input: this.state.dataPost,
                  id: selectedRow.id
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                  actions.resetForm({});
                  handleAdd();
                })
                .catch(err => {
                  message.error(err.message)
                })
            } 
            else {
              new Api_quantrac()
                .PostQT_DMQCVN_TNN({
                  token: this.props.user.access_token,
                  dmqcvn_input:  this.state.dataPost,
                  doituongQT: values.tpmT_Ma,
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_ADD_SUCCESS);
                  actions.resetForm({});
                  handleAdd();
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
          }}
          render={({
            errors,
            handleSubmit,
            touched,
            dirty,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit} autoComplete="false">
              <ControllerForm>
                <Row>
                  <Col span={12}>
                    <ControllerInput>
                    <Select
                      
                        placeholder={Helper.genSelectPL("Chọn đối tượng quan trắc")}
                        label={"Đối tượng quan trắc"}
                        onChange={value => setFieldValue("tpmT_Ma", value)}
                        dataSource={constant.THANH_PHAN_MOI_TRUONG}
                        width="100%"
                        name="ten"
                        name_value="id"
                        defaultValue={values.tpmT_Ma}
                        value={values.tpmT_Ma}
                        disabled={isEdit ? true : false}
                      />
                      <FastField name="maQuyChuan" render={({ field }) => (
                          <Input placeholder={typo.cscore_key} label={typo.cscore_key} mandatory={false} {...field} />)}/>
                      {touched.maQuyChuan && (<Text type="danger" className={styles.textFont}>{errors.maQuyChuan}</Text>)}

                      <FastField name="tenQuyChuan" render={({ field }) => (
                          <Input placeholder={typo.cscore_name_standard}label={typo.cscore_name_standard} {...field}/>)}/>
                      {touched.tenQuyChuan && ( <Text type="danger" className={styles.textFont}>{errors.tenQuyChuan}</Text>)}

                      <DateField
                        mandatory={false}
                        format={dateFormat}
                        placeholder={Helper.genSelectPL(typo.cscore_date_issued)} 
                        label={typo.cscore_date_issued} 
                        onChange={value => {setFieldValue("ngayBanHanh", value && value.format())}} 
                        defaultValue={values.ngayBanHanh}
                        value={values.ngayBanHanh ? moment(values.ngayBanHanh) : null}

                      />
                    </ControllerInput>
                  </Col>
                  <Col span={12}>
                    <ControllerInput>
                      <FastField name="coQuanBanHanh" render={({ field }) => (
                          <Input placeholder={typo.cscore_issuing_agency} label={typo.cscore_issuing_agency}mandatory={false} {...field} /> )}/>
                      {touched.coQuanBanHanh && ( <Text type="danger" className={styles.textFont}>{errors.coQuanBanHanh}</Text>)}

                      <Select
                        mandatory={false}
                        placeholder={Helper.genSelectPL(typo.cscore_hieuluc)}
                        label={typo.cscore_hieuluc}
                        onChange={value => setFieldValue("hieuLuc", value)}
                        dataSource={dataSelect}
                        width="100%"
                        name="ten"
                        name_value="value"
                        defaultValue={values.hieuLuc}
                        value={values.hieuLuc}
                      />
                      <FastField name="vanBanDinhKem" render={({ field }) => (
                          <Input placeholder={typo.cscore_file} label={typo.cscore_file}mandatory={false} {...field}/>)} />
                      {touched.vanBanDinhKem && (<Text type="danger" className={styles.textFont}>{errors.vanBanDinhKem}</Text>)}

                    </ControllerInput>
                  </Col>
                </Row>
                <Row>
                  <ControllerMDSD>
                    <Box size="small" label={typo.cscore_mucDichSuDung}>
                      <MDSD dataSource={dataMDSD.map((item, index) => ({...item, stt: index + 1}))} handleUpdate={this.handleUpdateMDSD} isEdit={isEdit} mode="GP"/>
                    </Box>
                  </ControllerMDSD>
                </Row>
                <ControllerButton>
                  <button
                    className='ant-btn'
                    type="submit"
                  >
                    <Icon type="save" style={{marginRight: "8px"}}/>
                    {typo.cscore_submit}
                  </button>
                  <Button
                    type="cancel"
                    className={styles.buttonMargin}
                    onClick={handleCloseModal}
                  >
                    <Icon type="arrow-right" />
                    {typo.cscore_exit}
                  </Button>
                </ControllerButton>
              </ControllerForm>
            </form>
          )}
        />
      </div>
    );
  }
}

AppliStanModal.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default AppliStanModal;
